var $459441d19cfa90a8$exports = {};
$459441d19cfa90a8$exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`
};


export {$459441d19cfa90a8$exports as default};
//# sourceMappingURL=he-IL.module.js.map
